import React from "react";

export const CardControlsRestartButton = (props) => {
  const bgColor = props.bgColor || "darkgrey";
  const margins = props.margins ? props.margins : "mt-3";
  const extraStyles = props.extraStyles ? props.extraStyles : {};

  return (
    <button
      type="button"
      className={"button full " + margins}
      style={{ backgroundColor: bgColor, color: "white", ...extraStyles }}
      onClick={props.backToCards}
      data-e2e-id="backToCards"
    >
      {props.buttonText}
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/misc/card-controls-restart-button.component.js